module.exports = __webpack_public_path__ + "static/media/_abkhazia.ed3efcd0.png";